import React from 'react';

import i18n from 'i18n-js';
import styles from '../styles';

interface TotalAmountProps {
    amount: number | string;
}

export default function TotalAmount(props: TotalAmountProps) {
    const classes = styles();
    return (
        <div
            className={`${classes.tabPriceContainer} ${classes.tabPriceAlignRight10}`}
            style={{ position: 'static' }}
        >
            <h4>{i18n.t('common.total')}: </h4>
            <div>
                <span className={classes.currencyText}>{i18n.t('common.currencies.chf')}</span>
                <span className={classes.currencyAmount}>{props.amount}</span>
            </div>
        </div>
    );
}
